import { render, staticRenderFns } from "./CreateBooking.vue?vue&type=template&id=0c169cba&scoped=true"
import script from "./CreateBooking.vue?vue&type=script&lang=ts"
export * from "./CreateBooking.vue?vue&type=script&lang=ts"
import style0 from "./CreateBooking.vue?vue&type=style&index=0&id=0c169cba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c169cba",
  null
  
)

export default component.exports